import { FAQ } from "../sections/FAQ";

export default function FaqPage() {
  return (
    <main className="pt-24" data-testid="faq-page">
      <FAQ />
    </main>
  );
}
